export class EmailCriteriaMaintenanceData {
	public emailId: string;
	public emailFrom: string;
	public emailSubject: string;
	public emailDateSent: string;
	public emailAddDate: string;
	public emailAttachments: {
		rateMatrixLoaderName: string;
		emailAttachmentId: number;
		isProcessed: boolean;
		attachmentId: string;
		attachmentName: string;
	}[];

	constructor(emailCriteriaMaintenanceData?: EmailCriteriaMaintenanceData) {
		Object.assign(this, emailCriteriaMaintenanceData);
	}
}
